<script lang="ts">
  import TextField from "./TextField.svelte";

  export let name: string;
  export let key: string;

  export let limit = 0;
  export let required = false;
  export let placeholder = "";
  export let autofocus = false;
  export let disabled = false;
  export let extension = false;

  const PHONE_REGEX = /^(\+[0-9]{1,3})?([-])?([0-9\-]{7,})$/;
  const EXTENSION_REGEX = /^[0-9]{0,4}$/;
</script>

<div class="flex justify-between">
  <div class="w-full">
    <TextField {key} {name} {limit} {required} {placeholder} {autofocus} {disabled} pattern={PHONE_REGEX} />
  </div>
  {#if extension}
    <div class="flex-shrink-0 w-1/5 ml-2">
      <TextField
        key={`${key}Extension`}
        name="Ext."
        placeholder="###"
        autofocus={false}
        {disabled}
        limit={4}
        forceLimit={true}
        showLimitIndicator={false}
        showOptionalIndicator={false} />
    </div>
  {/if}
</div>
